import { render, staticRenderFns } from "./AgreementBlock.vue?vue&type=template&id=1e90c957&scoped=true&"
import script from "./AgreementBlock.vue?vue&type=script&lang=ts&"
export * from "./AgreementBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementBlock.vue?vue&type=style&index=0&id=1e90c957&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90c957",
  null
  
)

export default component.exports